import React from 'react';

const Impressum = () => {
  return (
    <section id="impressum" className="py-20 px-4 bg-gradient-to-b from-black to-[#0a0a0a] min-h-screen">
      <div className="max-w-4xl mx-auto">
        {/* Section Title */}
        <div className="mb-16 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Impressum
          </h1>
          <div className="w-24 h-1 bg-amber-500 mx-auto" />
        </div>

        <div className="bg-gray-900/50 rounded-lg border border-gray-800 p-8 md:p-12 space-y-8">
          
          {/* Angaben gemäß */}
          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Angaben gemäß liechtensteinischem Recht</h2>
            <div className="text-gray-300 space-y-2">
              <p className="font-semibold text-white">Fabio Matt</p>
              <p>Heragass 22</p>
              <p>9492 Eschen</p>
              <p>Liechtenstein</p>
            </div>
          </div>

          {/* Kontakt */}
          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Kontakt</h2>
            <div className="text-gray-300 space-y-2">
              <p>
                <span className="text-gray-400">Telefon:</span> <a href="tel:+4237815306" className="text-amber-400 hover:text-amber-300 transition-colors">+423 781 53 06</a>
              </p>
              <p>
                <span className="text-gray-400">E-Mail:</span> <a href="mailto:fabiomatt2005@gmail.com" className="text-amber-400 hover:text-amber-300 transition-colors">fabiomatt2005@gmail.com</a>
              </p>
            </div>
          </div>

          {/* Inhaltlich verantwortlich */}
          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Verantwortlich für den Inhalt</h2>
            <div className="text-gray-300">
              <p>Fabio Matt (Anschrift wie oben)</p>
            </div>
          </div>

          {/* Haftungsausschluss */}
          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Haftungsausschluss</h2>
            
            <h3 className="text-lg font-semibold text-white mt-6 mb-3">Haftung für Inhalte</h3>
            <p className="text-gray-300 leading-relaxed mb-4">
              Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, 
              Vollständigkeit und Aktualität der Inhalte kann jedoch keine Gewähr übernommen werden. 
              Als Diensteanbieter bin ich gemäß liechtensteinischem Recht für eigene Inhalte auf 
              diesen Seiten verantwortlich. Die Nutzung der Inhalte der Website erfolgt auf eigene 
              Gefahr des Nutzers.
            </p>

            <h3 className="text-lg font-semibold text-white mt-6 mb-3">Haftung für Links</h3>
            <p className="text-gray-300 leading-relaxed mb-4">
              Diese Website enthält Links zu externen Websites Dritter, auf deren Inhalte ich keinen 
              Einfluss habe. Deshalb kann für diese fremden Inhalte auch keine Gewähr übernommen werden. 
              Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber 
              der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf 
              mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung 
              nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne 
              konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar.
            </p>

            <h3 className="text-lg font-semibold text-white mt-6 mb-3">Urheberrecht</h3>
            <p className="text-gray-300 leading-relaxed">
              Die durch mich erstellten Inhalte und Werke auf dieser Website unterliegen dem 
              liechtensteinischen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und 
              jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen meiner 
              schriftlichen Zustimmung. Downloads und Kopien dieser Seite sind nur für den privaten, 
              nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht von 
              mir erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden 
              Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung 
              aufmerksam werden, bitte ich um einen entsprechenden Hinweis.
            </p>
          </div>

          {/* Bildrechte */}
          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Bildrechte</h2>
            <p className="text-gray-300 leading-relaxed">
              Alle auf dieser Website gezeigten Fotografien sind urheberrechtlich geschützt und 
              Eigentum von Fabio Matt, sofern nicht anders angegeben. Die Verwendung, Vervielfältigung 
              oder Weitergabe der Bilder ohne ausdrückliche schriftliche Genehmigung ist untersagt.
            </p>
          </div>

          {/* Online-Streitbeilegung */}
          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Online-Streitbeilegung</h2>
            <p className="text-gray-300 leading-relaxed">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
              <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-amber-400 hover:text-amber-300 ml-1">
                https://ec.europa.eu/consumers/odr
              </a>. 
              Ich bin nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </div>

          {/* Stand */}
          <div className="pt-8 border-t border-gray-800">
            <p className="text-gray-500 text-sm">
              Stand: Januar 2025
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Impressum;
